export default __webpack_public_path__ + "static/media/card-1.e32b6a62.jpeg";